import { Text, View, StyleSheet } from '@react-pdf/renderer';
import React from 'react';
const styles = StyleSheet.create({
  title: {
    fontFamily: 'Helvetica-Bold',
    fontSize: '14px',
    color: '#2c3e50',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '0.8cm',
    paddingBottom: '0.3cm',
    borderBottom: '2px solid #548235',
  },
  content: {
    fontSize: '11px',
    color: '#34495e',
    lineHeight: 1.5,
    textAlign: 'justify',
  },
  highlight: {
    fontFamily: 'Helvetica-Bold',
    color: '#548235',
  },
});

function BudgetGuarantee(props) {
  const { guarantee } = props;
  return (
    <View>
      <Text style={styles.title}>3. Garantía de los Trabajos</Text>
      <Text style={styles.content}>
        <Text style={styles.highlight}>{guarantee}</Text>. Por efectos de fallas
        de fabricación, diseño o instalación no incluyendo en esta garantía los
        daños causados por intervenciones de terceros, actos de vandalismo,
        problemas de voltaje, desastres naturales, incendios, o daños no
        atribuibles a su uso normal.
      </Text>
    </View>
  );
}


export default BudgetGuarantee;
